/* eslint-disable consistent-return */
import React, { useEffect } from 'react';
import '../../stylesheets/app.scss';
import { Helmet } from 'react-helmet';
import { NavigationBarAndMenu, Footer } from '@library/shared-ui';
import SearchUiSuggestions from '../SearchUiSuggestions';
import initFullStory from './fullStory';
import { initZendeskWidget } from './zendesk';
import {
  getSessionStorage,
  setSessionStorage,
} from '../../utils/sessionManager';
import { ScreenSizeConfigurator } from '../../../../../library/shared-ui/components/ScreenSizeConfigurator';
import favicon from '../../images/android-chrome-512x512.png';
import { initApollo } from './apollo';

declare const window: any;

const Layout = ({ children, data }) => {
  const showToPercentage = (max) => {
    return Math.floor(Math.random() * Math.floor(max));
  };

  const schema = React.useMemo(
    () =>
      children?.props?.children?.props?.children?.props?.data ||
      children?.props?.data ||
      data,
    [
      children?.props?.children?.props?.children?.props?.data,
      children?.props?.data,
      data,
    ],
  );
  const locales = React.useMemo(
    () =>
      children?.props?.children?.props?.children?.props ||
      children?.props ||
      data,
    [children?.props?.children?.props?.children?.props, children?.props, data],
  );

  useEffect(() => {
    const fullStory = getSessionStorage('fullStory');
    // verifies we are in prod - random initialization of fullstory if new session
    if (process.env.GATSBY_TARGET_ENV === '1' && fullStory !== 'true') {
      if (showToPercentage(10) === 0) initFullStory();
      setSessionStorage('fullStory', 'true');
    }

    initZendeskWidget(process.env.GATSBY_ZENDESK_KEY);
    initApollo(process.env.GATSBY_APOLLO_APP_ID);
  }, []);

  return (
    <ScreenSizeConfigurator>
      <Helmet
        htmlAttributes={{ lang: 'en' }}
        link={[
          {
            rel: 'shortcut icon',
            type: 'image/png',
            href: `${favicon}`,
          },
        ]}
      >
        <meta name="fo-verify" content="0ab3c59e-9b79-4cb3-b5df-1833518fd597" />
      </Helmet>
      {!!schema?.contentfulPageTemplate?.navbarMenuSection && (
        <NavigationBarAndMenu
          featuredLinksMobileMenu={
            schema?.contentfulPageTemplate?.navbarMenuSection
              ?.featuredLinksMobileMenu
          }
          mobileNavigationLinks={
            schema?.contentfulPageTemplate?.navbarMenuSection
              ?.mobileNavigationLinks
          }
          featuredMobileSpot={
            schema?.contentfulPageTemplate?.navbarMenuSection
              ?.featuredMobileSpot
          }
          ctaButtons={
            schema?.contentfulPageTemplate?.navbarMenuSection?.ctaButtons
          }
          logo={schema?.contentfulPageTemplate?.navbarMenuSection?.logo}
          mobileShopMenu={
            schema?.contentfulPageTemplate?.navbarMenuSection?.mobileShopMenu
          }
          navigationLinks={
            schema?.contentfulPageTemplate?.navbarMenuSection?.navigationLinks
          }
          showSearchSuggestions
          searchSuggestions={<SearchUiSuggestions />}
          mobileButton={undefined}
        />
      )}
      <main>{children}</main>
      {!!schema?.contentfulPageTemplate?.footerSection && (
        <Footer
          columns={schema?.contentfulPageTemplate?.footerSection?.columns}
          infoColumn={schema?.contentfulPageTemplate?.footerSection?.infoColumn}
          logoContainer={
            schema?.contentfulPageTemplate?.footerSection?.logoContainer
          }
          bottomRow={schema?.contentfulPageTemplate?.footerSection?.bottomRow}
          pageContext={locales?.pageContext || locales?.allContentfulLocale}
        />
      )}
    </ScreenSizeConfigurator>
  );
};

export default Layout;
